import React from 'react'
import { Box } from '@mui/material'
import { addBranchSection, type ISurveySection } from '../../../store/slices/SurveyTemplateSlice'

import SurveySectionWrapper from './SurveySectionWrapper'
import { getSurveySections } from '../../../store/slices/SurveyTemplateSlice/selectors'
import { indentationColors } from '../constant'
import OutlineRoadMap from '../components/OutlineRoadMap'
import { isLastSectionInBranchGroup, isSectionInSameBranchGroup } from '../helpers'
import { useAppDispatch } from '../../../store'
import GenericButton from '../../../components/GenericButton'
import { ButtonType } from '../../../components/GenericButton/styles'
import AddIcon from '@mui/icons-material/Add'
import { SectionConnector, SectionList, SectionRow } from '../styles'
import CustomTooltip from '../../../components/CustomTooltip'

const SurveySections: React.FC = () => {
  const dispatch = useAppDispatch()
  const surveySectionsList = getSurveySections()

  return (
    <>
      <SectionList>
        {surveySectionsList?.map((section: ISurveySection, index: number) => {
          const previousSection = surveySectionsList[index - 1]
          const nextSection = surveySectionsList[index + 1]
          const hasIndentation = Boolean(section.indentation)
          const shouldConnectTop = isSectionInSameBranchGroup(previousSection, section)
          const showBranchGroupAddSectionButton = isLastSectionInBranchGroup(surveySectionsList, section)
          const shouldConnectBottom = isSectionInSameBranchGroup(section, nextSection)
          const handleAddGroupedBranchSection = (): void => {
            if (!section.parentSurveySectionId || !section.branchingFilters) {
              return
            }

            dispatch(addBranchSection({
              parentSurveySectionId: section.parentSurveySectionId,
              branchingFilters: {
                ...section.branchingFilters,
                answer: [...(section.branchingFilters.answer ?? [])]
              }
            }))
          }

          return (
            <Box key={section.surveySectionId} width="100%" display="flex" flexDirection="column" alignItems="center">
              <SectionRow
                pl={`${section.indentation * 30}px`}
                style={showBranchGroupAddSectionButton ? { marginBottom: '24px' } : undefined}
              >
                {hasIndentation &&
                  <SectionConnector
                    connectorColor={indentationColors[section.indentation] ?? indentationColors[5]}
                    connectTop={shouldConnectTop}
                    connectBottom={shouldConnectBottom}
                  />
                }
                <Box flex={1} display='flex' flexDirection='column' gap={2}>
                  <SurveySectionWrapper
                    section={section}
                    sectionIndex={index}
                    surveySectionsList={surveySectionsList}
                  />
                  {showBranchGroupAddSectionButton && (
                    <Box display='flex' justifyContent='center' mt={2}>
                      <CustomTooltip title="Create a new survey section for this conditional branch">
                        <GenericButton
                          buttonType={ButtonType.Secondary}
                          startIcon={<AddIcon />}
                          label='Add Section'
                          fontWeight='bold'
                          onClick={handleAddGroupedBranchSection}
                        />
                      </CustomTooltip>
                    </Box>
                  )}
                </Box>
              </SectionRow>
            </Box>
          )
        })}
      </SectionList>

      <OutlineRoadMap surveySection={surveySectionsList} />
    </>
  )
}

export default SurveySections
